<div class="dropdown country-dropdown">
  <a [attr.data-test]="formCtrlName||'selectInput'" class="dropdown-toggle" href="#"  role="button" [id]="id" data-bs-toggle="dropdown"
    aria-expanded="false">
    <app-flag class="flag" [code]="selectedCode" [codeDefault]="selectedCodeDefault"></app-flag>
    <span *ngIf="displayMode === 'code'">{{selectedCode}}</span>
    <span *ngIf="displayMode === 'country'">{{selectedCountryName}}</span>
  </a>
  <div>
    <div class="dropdown-menu code-dropdown" [attr.aria-labelledby]="id" >
      <!-- <input type="text" [formGrp]="searchForm" placeholder="Search..."  /> -->
      <app-input  [formGrp]="searchForm" formCtrlName="searchTerm"  [label]="'Search...'"></app-input>

      <ul>

        <li *ngFor="let code of displayedCountries" (click)="onSelectCode(code)">
          <a class="dropdown-item" [attr.data-test]="code">
            <!-- <app-flag [code]="code"></app-flag> -->
            <img width="28" height="20" [src]="'https://flagcdn.com/w40/'+getImage(code?.image)">
            <span *ngIf="displayMode === 'code'">{{code.dial_code}}</span>
            <span>{{code.name}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
